import { HStack } from "@/components/layout";
import Header from "./header";
import MetricsCards from "./metrics-cards";
import StatementPagesChart from "./statements-pages-chart";
import ProjectsTable from "./table";

export default function ProjectsList({ projects }) {
  return (
    <>
      <Header />
      <HStack className="mb-14 hidden w-full flex-col justify-between gap-6 lg:gap-8 xl:flex-row xl:gap-10 2xl:gap-16">
        <StatementPagesChart />
        <MetricsCards />
      </HStack>
      <ProjectsTable projects={projects} />
    </>
  );
}
